import React, { Component } from "react";
import { view } from "react-easy-state";
import Color from "color";
import UnitInput from "./UnitInput";
import uniqid from "uniqid";
import css from "./HSVPicker.module.css";

class HSVPicker extends Component {
  state = {
    color: {
      hsv: Color(this.props.color).hsv().color
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      let thisColor = Color.hsv(this.state.color.hsv);
      let newColor = Color(this.props.color);

      // Prioritize internal HSV if RGB's are identical
      if (
        JSON.stringify(thisColor.rgb().color) !==
        JSON.stringify(newColor.rgb().color)
      ) {
        this.setState({ color: { hsv: newColor.hsv().color } });
      }
    }
  }

  setColor = color => {
    this.props.onChange(Color.hsv(color.hsv).rgb().color);
    this.setState({ color: color });
  };

  handleHueChange = value => {
    let thisColor = this.state.color;
    thisColor.hsv[0] = parseInt(value, 10);
    this.setColor(thisColor);
  };

  handleSaturationChange = value => {
    let thisColor = this.state.color;
    thisColor.hsv[1] = parseInt(value, 10);
    this.setColor(thisColor);
  };

  handleValueChange = value => {
    let thisColor = this.state.color;
    thisColor.hsv[2] = parseInt(value, 10);
    this.setColor(thisColor);
  };

  render() {
    let thisColor = Color.hsv(this.state.color.hsv);

    let style = {
      mainColor: {
        backgroundColor: thisColor.rgb().string()
      },
      secondaryColor: {
        backgroundColor: "black"
      }
    };

    return (
      <div className={css.container}>
        <div className={css.left}>
          <div style={style.mainColor} className={css.color} />
          <div style={style.secondaryColor} className={css.color} />
        </div>
        <div className={css.right}>
          <div className={css.sliderContainer}>
            <label className={css.label}>H</label>
            <HueSlider
              min={0}
              max={360}
              value={this.state.color.hsv[0]}
              onChange={this.handleHueChange}
              color={thisColor}
            />
            <UnitInput
              min={0}
              max={360}
              value={this.state.color.hsv[0]}
              suffix={"°"}
              onValueChange={this.handleHueChange}
            />
          </div>
          <div className={css.sliderContainer}>
            <label className={css.label}>S</label>
            <SaturationSlider
              min={0}
              max={100}
              value={this.state.color.hsv[1]}
              onChange={this.handleSaturationChange}
              color={thisColor}
            />
            <UnitInput
              min={0}
              max={100}
              value={this.state.color.hsv[1]}
              suffix={"%"}
              onValueChange={this.handleSaturationChange}
            />
          </div>
          <div className={css.sliderContainer} style={{ marginBottom: 0 }}>
            <label className={css.label}>V</label>
            <ValueSlider
              min={0}
              max={100}
              value={this.state.color.hsv[2]}
              onChange={this.handleValueChange}
              color={thisColor}
            />
            <UnitInput
              min={0}
              max={100}
              value={this.state.color.hsv[2]}
              suffix={"%"}
              onValueChange={this.handleValueChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

class HueSlider extends Component {
  myRef = React.createRef();
  uid = uniqid();

  render() {
    let thisCol = Color(this.props.color);
    thisCol.color[1] = 100;
    thisCol.color[2] = 100;
    thisCol = thisCol.rgb().string();

    return (
      <React.Fragment>
        <style>
          {`
          .${this.uid}::-webkit-slider-thumb {
            background-color: ${thisCol} !important;
          }
        `}
        </style>

        <input
          className={`${css.slider} ${css.HueSlider} ${this.uid}`}
          type="range"
          min={this.props.min}
          max={this.props.max}
          value={this.props.value}
          onChange={e => {
            this.props.onChange(e.target.value);
          }}
          color={this.props.color}
          style={{ flexGrow: 1 }}
          tabIndex={-1}
        />
      </React.Fragment>
    );
  }
}

class SaturationSlider extends Component {
  uid = uniqid();

  render() {
    let props = this.props;
    return (
      <React.Fragment>
        <style>
          {`
          .${this.uid}::-webkit-slider-runnable-track {
            background: linear-gradient(
              to right,
              ${(props => {
                let thisCol = Color(props.color);
                thisCol.color[1] = 0;
                return thisCol.rgb().string();
              })(props)}
              0%,
              ${(props => {
                let thisCol = Color(props.color);
                thisCol.color[1] = 100;
                return thisCol.rgb().string();
              })(props)}
              100%
            ) !important;
          }
          .${this.uid}::-webkit-slider-thumb {
            background-color: ${(props => props.color.rgb().string())(
              props
            )} !important;

          }
        `}
        </style>

        <input
          className={`${css.slider} ${this.uid}`}
          type="range"
          min={props.min}
          max={props.max}
          value={props.value}
          onChange={e => {
            props.onChange(e.target.value);
          }}
          color={props.color}
          style={{ flexGrow: 1 }}
          tabIndex={-1}
        />
      </React.Fragment>
    );
  }
}

class ValueSlider extends Component {
  uid = uniqid();

  render() {
    let props = this.props;
    return (
      <React.Fragment>
        <style>
          {`
        .${this.uid}::-webkit-slider-runnable-track {
          background: linear-gradient(
            to right,
            #000 0%,
            ${(props => {
              let thisCol = Color(props.color);
              thisCol.color[2] = 100;
              return thisCol.rgb().string();
            })(props)}
            100%
          ) !important;
        }
        .${this.uid}::-webkit-slider-thumb {
          background-color: ${(props => props.color.rgb().string())(
            props
          )} !important;
        }
      `}
        </style>

        <input
          className={`${css.slider} ${this.uid}`}
          type="range"
          min={props.min}
          max={props.max}
          value={props.value}
          onChange={e => {
            props.onChange(e.target.value);
          }}
          color={props.color}
          style={{ flexGrow: 1 }}
          tabIndex={-1}
        />
      </React.Fragment>
    );
  }
}

export default view(HSVPicker);
